<template>
    <div class="bs-fields">
        <label v-for="(value,key) in params" :key="key">{{ fieldLabel(key) }}
            <select v-if="typeof value === 'string'" :value="value" @change="update(key, $event.target.value)"><option v-for="option in choices(key, value)" :key="option" :value="option">{{ option }}</option></select>
            <input v-else :value="value" type="number" :step="isPeriod(key) ? 1 : 'any'" :min="isPeriod(key) ? 1 : undefined" :max="isPeriod(key) ? 500 : undefined" @input="update(key, $event.target.value === '' ? null : Number($event.target.value))" />
        </label>
        <small v-if="!Object.keys(params).length" class="bs-muted">This rule uses the current and previous completed candles.</small>
    </div>
</template>
<script>
import { fieldLabel } from './core-strategies.mjs';
export default {
    name: 'StrategyFields', props: { params: { type: Object, required: true }, indicators: { type: Array, default: () => [] } },
    methods: {
        fieldLabel, isPeriod: key => /period|length|lookback|^fast$|^slow$|^signal$/i.test(key),
        choices(key, current) { return [...new Set([current, ...(key === 'indicator' ? this.indicators.map(item => item.type) : key === 'requireTrendDirection' ? ['above', 'below'] : ['SMA', 'EMA', 'WMA', 'HMA', 'DEMA', 'TEMA'])])]; },
        update(key, value) { this.$emit('input', { ...this.params, [key]: value }); },
    },
};
</script>
